import { ReactNode } from 'react';

interface ActionCardTitleProps {
	children: ReactNode;
}

export function ActionCardTitle({ children }: ActionCardTitleProps) {
	return <span className='c-action-card__title'>{children}</span>;
}
